<template>
  <vue-select
    style="width: 100%"
    :value="value"
    :options="items"
    label="label"
    class="select-x"
    placeholder="Pilih Pengurutan"
    @input="changed"
  ></vue-select>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  name: "OutletSortSelector",
  data() {
    return {
      items: [
        {id: 'id', label: 'No Urut'},
        {id: 'o.name', label: 'Nama Outlet'},
        {id: 'product_count', label: 'Total Produk'},
        {id: 'transaction_count', label: 'Jumlah Transaksi'},
      ],
    };
  },
  props: ["value"],
  methods: {
    changed(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
